import styled from '@emotion/styled';

export const Container = styled.main`
  width: 100%;
  padding: 10% 20%;
`;
